/**
 * ArticleNavigation - Navigation component for knowledge base articles
 * 
 * PROJECT_RULES.md Compliance:
 * - ✅ Consistent design language
 * - ✅ TypeScript: Fully typed
 */

import React from 'react';
import { Link } from 'react-router-dom';
import type { NavigationProps } from '../types';
import { DEFAULT_COLOR } from '../constants';

export const ArticleNavigation: React.FC<NavigationProps> = ({ category, article, accentColor }) => {
  const relatedArticles = [
    {
      category: 'recipes',
      excludeArticle: 'how-to-add-recipe',
      link: '/knowledge-base/recipes/how-to-add-recipe',
      text: 'How to Add Recipes →'
    },
    {
      category: 'meal-planning',
      excludeArticle: 'add-to-meal-plan',
      link: '/knowledge-base/meal-planning/add-to-meal-plan',
      text: 'Add to Meal Plan →'
    }
  ];

  return (
    <div className="mt-8 flex justify-between">
      <Link 
        to="/knowledge-base" 
        className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all hover:shadow-lg"
        style={{ 
          backgroundColor: 'white',
          color: DEFAULT_COLOR,
          border: `2px solid ${accentColor}`
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        Back to Knowledge Base
      </Link>

      {/* Related Articles */}
      <div className="flex gap-4">
        {relatedArticles.map(relatedArticle => (
          category === relatedArticle.category && article !== relatedArticle.excludeArticle && (
            <Link 
              key={relatedArticle.link}
              to={relatedArticle.link} 
              className="px-6 py-3 rounded-lg font-semibold transition-all hover:shadow-lg"
              style={{ 
                backgroundColor: accentColor,
                color: 'white'
              }}
            >
              {relatedArticle.text}
            </Link>
          )
        ))}
      </div>
    </div>
  );
};